module.exports = __webpack_public_path__ + "static/img/净水器.f91a4f40.png";